import React from 'react'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { ProgressSpinner } from 'primereact/progressspinner'
import { UsuarioService } from '../../Domain/Services/Usuario.service'
import logo from '../Assets/Img/logex.png'

import '../Assets/Css/Login.css'

interface Autenticacion{
    grant_type: string,
    code: string,
    redirect_uri: string,
    Credencial:{
        Usuario: string,
        Contraseña: string,
    },
    refresh_token: string,
}

interface IProps {
}

interface IState {
    Autenticacion: Autenticacion,
    IsLoading: boolean,
    ErrorMessage: string,
    Transitioning: boolean
}

export default class Login extends React.Component<IProps, IState> {

    constructor(props : any){
        super(props)
        this.state = {
            Autenticacion:{
                grant_type: '',
                code: '',
                redirect_uri: '',
                Credencial:{
                    Usuario: '',
                    Contraseña: '',
                },
                refresh_token: '',
            },
            IsLoading: false,
            ErrorMessage: '',
            Transitioning: false
        }
    }

    componentDidMount(){
        localStorage.removeItem('TOKEN-UN1FL3X')
    }

    HandleChange = (e : React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            ErrorMessage: '',
            Autenticacion:{
                ...this.state.Autenticacion,
                Credencial:{
                    ...this.state.Autenticacion.Credencial,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    HandleSubmit = (e : React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!this.state.Autenticacion.Credencial.Usuario || !this.state.Autenticacion.Credencial.Contraseña) {
            this.setState({ ErrorMessage: 'Ingrese usuario y contraseña' })
            return
        }
        this.setState({
            IsLoading: true,
            ErrorMessage: ''
        }, () => {this.Autenticar()})
    };

    Autenticar(){ 
        UsuarioService.Autenticar(this.state.Autenticacion)
        .then( (data : any) => {
            if(data.success){
                var info = JSON.parse(data.data);
                localStorage.setItem('TOKEN-UN1FL3X',info.access_token)
                this.setState({ Transitioning: true })
                setTimeout(() => {
                    window.location.assign('Documento')
                }, 700)
            }else{
                this.setState({ ErrorMessage: data.data, IsLoading: false })
            }
        })
        .catch( error => {
            this.setState({ ErrorMessage: error?.message || error || 'Error de conexión', IsLoading: false })
        })
    }

    render(){
        return(
            <div className={`login-page ${this.state.Transitioning ? 'transitioning' : ''}`}>
                <div className={`login-brand ${this.state.Transitioning ? 'slide-left' : ''}`}>
                    <div className="login-brand-content">
                        <div className="login-logo">
                            <img src={logo} alt="Touchless Payments" />
                        </div>
                        <h1 className="login-brand-title">Touchless Payments</h1>
                        <p className="login-brand-subtitle">Gestión de reglas promocionales y descuentos para distribuidoras</p>
                    </div>
                </div>
                <div className={`login-form-panel ${this.state.Transitioning ? 'slide-right' : ''}`}>
                    <div className="login-form-container">
                        <div className="login-form-header">
                            <h2 className="login-form-title">Iniciar sesión</h2>
                            <p className="login-form-desc">Ingrese sus credenciales para acceder al sistema</p>
                        </div>

                        {this.state.ErrorMessage && (
                            <div className="login-error">
                                <i className="pi pi-exclamation-circle"></i>
                                <span>{this.state.ErrorMessage}</span>
                            </div>
                        )}

                        <form autoComplete="off" onSubmit={this.HandleSubmit} className="login-form">
                            <div className="login-field">
                                <label className="login-label">Usuario</label>
                                <span className="p-input-icon-left login-input-icon">
                                    <i className="pi pi-user" />
                                    <InputText
                                        value={this.state.Autenticacion.Credencial.Usuario}
                                        name="Usuario"
                                        onChange={this.HandleChange}
                                        type="text"
                                        placeholder="Ingrese su usuario"
                                        className="login-input"
                                    />
                                </span>
                            </div>
                            <div className="login-field">
                                <label className="login-label">Contraseña</label>
                                <span className="p-input-icon-left login-input-icon">
                                    <i className="pi pi-lock" />
                                    <InputText
                                        value={this.state.Autenticacion.Credencial.Contraseña}
                                        name="Contraseña"
                                        onChange={this.HandleChange}
                                        type="password"
                                        placeholder="Ingrese su contraseña"
                                        className="login-input"
                                    />
                                </span>
                            </div>
                            <Button
                                label={this.state.IsLoading ? 'Ingresando...' : 'Ingresar'}
                                className="login-button"
                                disabled={this.state.IsLoading}
                            />
                            {this.state.IsLoading && (
                                <div className="login-spinner">
                                    <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="4" />
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
